// extracted by mini-css-extract-plugin
export var activeTab = "SalesWrapper-module--activeTab--EEXbW";
export var container = "SalesWrapper-module--container--aO+8J";
export var tabs = "SalesWrapper-module--tabs--NP8QW";